module.exports = __webpack_public_path__ + "img/tspT.73eb1d6d.png";